/**
 * Created by mly on 2017/12/19.
 */
const util = {
    isPointInLine(item, x, y) {
        const p = {x, y};
        const p1 = {x: item.data.x1, y: item.data.y1};
        const p2 = {x: item.data.x2, y: item.data.y2};
        // 取直线顶点在垂线上的左右offset px两点，组成一个正方形，作为直线的点击区域
        let poly, offset = 2;
        if (p2.y === p1.y) {
            // 直线与x轴平行
            poly = [
                {x: p1.x, y: p1.y + offset},
                {x: p2.x, y: p2.y + offset},
                {x: p2.x, y: p2.y - offset},
                {x: p1.x, y: p1.y - offset},
            ];
        } else if (p2.x === p1.x) {
            // 直线与y轴平行
            poly = [
                {x: p1.x - offset, y: p1.y},
                {x: p1.x + offset, y: p1.y},
                {x: p2.x + offset, y: p2.y},
                {x: p2.x - offset, y: p2.y},
            ];
        } else {
            // 计算直线斜率
            const line_slope = (p2.y - p1.y) / (p2.x - p1.x);
            // 计算直线垂线斜率
            const vertical_slope = -1 / line_slope;
            // y / x = slope
            let offset_x = Math.sqrt(Math.pow(offset, 2) / (1 + Math.pow(vertical_slope, 2)));
            const offset_y = vertical_slope * offset_x;
            if (vertical_slope > 0) {
                offset_x = -offset_x;
            }
            poly = [
                {x: p1.x + offset_x, y: p1.y + offset_y},
                {x: p2.x + offset_x, y: p2.y + offset_y},
                {x: p2.x - offset_x, y: p2.y - offset_y},
                {x: p1.x - offset_x, y: p1.y - offset_y},
            ];
        }
        return util.rayCasting(p, poly);
    },
    isPointInRectangle(item, x, y) {
        const p = {x, y};
        const start = {x: item.data.x, y: item.data.y};
        const h = item.data.h;
        const w = item.data.w;
        const poly = [
            {x: start.x, y: start.y},
            {x: start.x + w, y: start.y},
            {x: start.x + w, y: start.y + h},
            {x: start.x, y: start.y + h},
        ];
        return util.rayCasting(p, poly);
    },
    isPointInCircle(item, x, y) {
        const p = {x, y};
        const center = {x: item.data.x, y: item.data.y};
        const d = item.data.d;
        const poly = [
            {x: center.x - d, y: center.y + d},
            {x: center.x + d, y: center.y + d},
            {x: center.x + d, y: center.y - d},
            {x: center.x - d, y: center.y - d},
        ];
        return util.rayCasting(p, poly);
    },
    isPointInEllipse(item, x, y) {
        const p = {x, y};
        const center = {x: item.data.x, y: item.data.y};
        const w = item.data.w;
        const h = item.data.h;
        const poly = [
            {x: center.x - w / 2, y: center.y - h / 2},
            {x: center.x + w / 2, y: center.y - h / 2},
            {x: center.x + w / 2, y: center.y + h / 2},
            {x: center.x - w / 2, y: center.y + h / 2},
        ];
        return util.rayCasting(p, poly);
    },
    isPointInLinearPath(item, x, y) {
        const points = item.data.points;
        const len = points.length;
        for (let i = 0, j = 1; i < len - 1; i++, j++) {
            const p1 = points[i];
            const p2 = points[j];
            const line_item = {data: {x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y}};
            if (util.isPointInLine(line_item, x, y)) {
                return true;
            }
        }
        return false;
    },
    isPointInPolygon(item, x, y) {
        const p = {x, y};
        const poly = item.data.points;
        return util.rayCasting(p, poly);
    },
    isPointInArc(item, x, y) {
        const p = {x, y};
        const center = {x: item.data.x, y: item.data.y};
        const w = item.data.w;
        const h = item.data.h;
        const poly = [
            {x: center.x - w / 2, y: center.y - h / 2},
            {x: center.x + w / 2, y: center.y - h / 2},
            {x: center.x + w / 2, y: center.y + h / 2},
            {x: center.x - w / 2, y: center.y + h / 2},
        ];
        return util.rayCasting(p, poly);
    },
    isPointInCurve(item, x, y) {
        const p = {x, y};
        const points = item.data.points;
        const es = points.map((point) => {return point.x});
        const ys = points.map((point) => {return point.y});
        const min_x = Math.min(...es);
        const max_x = Math.max(...es);
        const min_y = Math.min(...ys);
        const max_y = Math.max(...ys);
        const poly = [
            {x: min_x, y: min_y},
            {x: max_x, y: min_y},
            {x: max_x, y: max_y},
            {x: min_x, y: max_y},
        ];
        return util.rayCasting(p, poly);
    },
    isPointInLabel(label, x, y) {
        const p = {x, y};
        const poly = [
            {x: label.x, y: label.y},
            {x: label.x + label.w, y: label.y},
            {x: label.x + label.w, y: label.y + label.h},
            {x: label.x, y: label.y + label.h},
        ];
        return util.rayCasting(p, poly);
    },
    /* 射线法判断一点是否在多边形内
     * Object p {x: 坐标, y: 坐标}
     * Array poly [{x: 坐标, y: 坐标}, {x: 坐标, y: 坐标}, ...]
     * return true or false
     */
    rayCasting(p, poly) {
        const px = p.x, py = p.y;
        let is_point_in = false;
        for (let i = 0, len = poly.length, j = len - 1; i < len; j = i++) {
            const sx = poly[i].x, sy = poly[i].y;
            const ex = poly[j].x, ey = poly[j].y;
            // 点与多边形顶点重合
            if ((sx === px && sy === py) || (ex === px && ey === py)) {
                return true;
            }
            // 判断线段两端点是否在射线两侧
            if ((sy < py && ey >= py) || (sy >= py && ey < py)) {
                // 线段上与射线 Y 坐标相同的点的 X 坐标
                const x = sx + (py - sy) * (ex - sx) / (ey - sy);
                // 叉乘法判断点是否在线段上（即多边形的边上）
                if (x === px) {
                    return true;
                }
                // 射线穿过多边形的边界
                if (x > px) {
                    is_point_in = !is_point_in
                }
            }
        }
        // 射线穿过多边形边界的次数为奇数时点在多边形内
        return is_point_in;
    }
};

export default util;
